export const GENERAL_CONSTS = {
    MAX_INTEREST: "3.48",
    INVESTOR_PORTAL_TOOLTIP: "When the switch is on, investors can view the holding in their Investor Portal and receive updates.",
    NAV_TOOLTIP: "Net Asset Value (NAV) is calculated using this formula: (Estimated Market Value - Loan Amount) × Investor Ownership Percentage. To configure this field, navigate to Edit Asset → Investment Details.",
    SHARES_TOOLTIP: "Turning on 'Display Shares' will show the LP the number of shares they hold, calculated as their contributions or commitments divided by the Price Per Unit (PPU) specified in the investment details tab.",
    INCLUDE_UNREALIZED_NAV_TOOLTIP: "Toggle to include Unrealized NAV in Unrealized Equity Multiple and IRR calculations"


}